import { jsx as _jsx } from "react/jsx-runtime";
import colors from "@colors/colors";
import constants from "@utils/constants";
import { FaInstagram } from "react-icons/fa";
import RoundedButton from "./roundedButton/RoundedButton";
const InstagramButton = () => {
    return (_jsx(RoundedButton, { text: "Instagram", background: "linear-gradient(45deg, #f58529, #dd2a7b, #8134af, #515bd4)", textColor: colors.white, iconColor: colors.white, icon: FaInstagram, href: constants.instagramUrl }));
};
export default InstagramButton;
